import React from "react";

const CheckBox = ({ className }) => {
  return (
    <div>
      <svg
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path d="M6.06668 10.0667L10.7667 5.36671L9.83334 4.43337L6.06668 8.20004L4.16668 6.30004L3.23334 7.23337L6.06668 10.0667ZM7.00001 13.6667C6.07779 13.6667 5.21112 13.4917 4.40001 13.1417C3.5889 12.7917 2.88334 12.3167 2.28334 11.7167C1.68334 11.1167 1.20834 10.4112 0.858343 9.60004C0.508343 8.78893 0.333344 7.92226 0.333344 7.00004C0.333344 6.07782 0.508343 5.21115 0.858343 4.40004C1.20834 3.58893 1.68334 2.88337 2.28334 2.28337C2.88334 1.68337 3.5889 1.20837 4.40001 0.858374C5.21112 0.508374 6.07779 0.333374 7.00001 0.333374C7.92223 0.333374 8.7889 0.508374 9.60001 0.858374C10.4111 1.20837 11.1167 1.68337 11.7167 2.28337C12.3167 2.88337 12.7917 3.58893 13.1417 4.40004C13.4917 5.21115 13.6667 6.07782 13.6667 7.00004C13.6667 7.92226 13.4917 8.78893 13.1417 9.60004C12.7917 10.4112 12.3167 11.1167 11.7167 11.7167C11.1167 12.3167 10.4111 12.7917 9.60001 13.1417C8.7889 13.4917 7.92223 13.6667 7.00001 13.6667Z" />
      </svg>
    </div>
  );
};

export default CheckBox;
